import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import Imagen1 from "../../../images/modulo12/anuncio.png";
import Imagen2 from "../../../images/modulo12/busarequipa.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad4.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[4];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[5].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[5].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[3].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[3].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-10 col-12 p-0">
          <ul className="">
            <li>
            ¿Qué está pasando en las imágenes? Escribe una palabra o frase que lo explique. 
            </li>
            <li>
              Usa las palabras de las actividades anteriores: discriminar,
              migrar, incluir, excluir.
            </li>
          </ul>
        </div>
      </div>

      <div className="row text-center">
        <div className="col-md-6 col-12">
          <Card>
            <img src={Imagen1} alt="Anuncio" className="img-fluid" />
            <textarea className="form-control" rows={3} />
          </Card>
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <img src={Imagen2} alt="Bus" className="img-fluid" />
            <textarea className="form-control" rows={3} />
          </Card>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las dos indicaciones: ¿Qué está
            pasando en las imágenes? Escribe una palabra o frase que lo
            explique. Usa las palabras de las actividades previas.
          </li>

          <li>
            Pida a niños y niñas que describan las imágenes. Ayúdelos haciendo
            preguntas. Por ejemplo:
            <ul>
              <li>
                Para la primera imagen: “¿Qué vemos en la primera imagen? ¿Qué
                dice el letrero? ¿Cómo crees que se siente la persona que lee el
                letrero?”
              </li>

              <li>
                Para la segunda imagen: “¿Con qué palabra se puede asociar la
                imagen? ¿Por qué se puede asociar con esa palabra?”.
              </li>
            </ul>
          </li>

          <li>
            Para la primera imagen, la idea es que se den cuenta
            de que se trata de una situación en la que se discrimina al que no
            es de Lima. Podrían escribir “Discriminación” o
            “Discriminación por ser de provincia”. En la segunda imagen, una
            persona está migrando a la ciudad. Los niños y niñas podrían
            escribir “Migración” o “Migración a la ciudad de Arequipa”.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
